module.exports = __webpack_public_path__ + "static/media/google_drive.f5fd3e02.png";